import { Orbit } from './Orbit.tsx';
import { Checkmark } from './pieces/index.ts';

type Props = Omit<React.ComponentProps<typeof Orbit>, 'children'>;

export function OrbitSuccess(props: Props) {
  return (
    <Orbit {...props}>
      <Checkmark />
    </Orbit>
  );
}
